import Vue from './vue-config'

if (document.getElementById('faqpage')) {
    new Vue({
        el: '#faqpage',
        data: {
            faqs: faqs,
            cats: cats,
            catId: 0,
        },
        computed: {
            items() {
                return this.faqs.filter(f => this.catId == 0 || f.CatIds.includes(this.catId))
            }
        },
        mounted() {
            if (this.cats.length)
                this.catId = this.cats[0].Id
        }
    })
}